module.exports = __webpack_public_path__ + "static/media/product-checkout-1.c1707090.png";